<template>
    <div v-if="item[name].length">
        <div v-for="(i, index) in item[name]" :style="icon === '' ? 'display:inline-block;' : ''" :class="myclasses(index, true)">
            <i v-if="icon !== ''" class="icon " :class="icon"></i>
            <ais-highlight
                    :hit="item"
                    :attribute="attribute_name(index)"
                    :class-names="myclasses(index)"
                    :key="attribute_name(index)"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "search-highlight",
        props: {
            classes: {
                type: Object,
                default() {
                    return {}
                },
            },
            icon: { default : '' },
            item: { default : '' },
            hide: { default : true },
            name: { default : '' },
        },
        methods: {
            attribute_name(index) {
                return this.name + '.' + index;
            },
            myclasses(index, outputHide) {
                let list = Object.assign({}, this.classes);

                if (typeof this.item._highlightResult[this.name] !== 'undefined' && this.item._highlightResult[this.name][index].matchLevel === 'none') {
                    if (typeof list['ais-Highlight'] === 'undefined') {
                        list['ais-Highlight'] = '';
                    }
                    if (this.hide) {
                        list['ais-Highlight'] += ' hide';
                        if (typeof outputHide !== 'undefined' && outputHide) {
                            return 'hide';
                        }
                    }
                }
                if (typeof outputHide !== 'undefined' && outputHide) {
                    if (this.name === 'tags') return '';
                    return 'hit-line';
                }
                return list;
            }
        }
    }
</script>

<style scoped>

</style>